<template>
    <div class="vm-goal-group">
        <template v-for="(goal, i) in sum_income_goal_list">
            <goal :goal="goal" :key="goal.goal_id" :user="user" :is_show_sum_info="i == 0"></goal>
        </template>
        <!-- <div v-if="sum_income_goal_list.length > 0" class="line mb24"></div> -->
        <goal v-for="(goal, i) in sponsor_goal_list" :goal="goal" :key="goal.goal_id" :user="user"></goal>
        <goal v-for="(goal, i) in money_goal_list" :goal="goal" :key="goal.goal_id" :user="user"></goal>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'goal-group',
    props: {
        list:{
            default(){
                return []
            },
        },
        user:{
            default(){
                return {}
            },
        },
    },
    components:{
    },
    data() {
        return {
        }
    },
    computed:{
        ...mapState('app',[
            'goal_type',
            'goal_status',
            'session_user',
        ]),
        sponsor_goal_list(){
            return this.list.filter((v) => v.type == this.goal_type.sponsor).sort((a,b) => a.monthly_fans - b.monthly_fans)
        },
        money_goal_list(){
            return this.list.filter((v) => v.type == this.goal_type.money).sort((a,b) => a.monthly_income - b.monthly_income)
        },
        sum_income_goal_list(){
            return this.list.filter((v) => v.type == this.goal_type.sum_income)
        }
    },
    mounted() {

    },
    methods: {

    }
};
</script>

<style lang="stylus" scoped>
.vm-goal-group{
    .vm-goal{
        margin-bottom px2rem(24)
        &:last-child{
            margin-bottom 0
        }
    }
}
</style>
